import React from 'react';
import ArrayFieldSection from './ArrayFieldSection';

const FormFieldRenderer = ({ field, formData, setFormData, dropdownData }) => {
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'number' ? parseInt(value, 10) : value
    }));
  };

  // Render array-type fields (with subfields)
  if (field.subfields) {
    return (
      <ArrayFieldSection
        field={field}
        formData={formData}
        setFormData={setFormData}
        dropdownData={dropdownData}
      />
    );
  }

  const value = formData[field.fields] || "";

  return (
    <div className="form-group">
      <label className="form-label">{field.fields}</label>

      {/* API-based dropdown */}
      {field.api && field.type === 'ObjectId' ? (
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleChange}
          required
        >
          <option value="">Select {field.fields}</option>
          {dropdownData[field.fields]?.map((item) => (
            <option key={item.id} value={item.id}>{item.label}</option>
          ))}
        </select>

      ) : field.options ? (
        // Enum dropdown
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleChange}
          required
        >
          <option value="">Select {field.fields}</option>
          {field.options.map((opt, i) => (
            <option key={i} value={opt}>{opt}</option>
          ))}
        </select>

      ) : field.type === 'number' ? (
        <input
        className="form-input"
        type="number"
        name={field.fields}
        value={value}
        onChange={handleChange}
        required
        inputMode="numeric"
        pattern="[0-9]*"
        onKeyDown={(e) => {
          if (
            ['e', 'E', '+', '-', '.'].includes(e.key) ||
            (e.key === ' ' || isNaN(Number(e.key)) && e.key.length === 1)
          ) {
            e.preventDefault();
          }
        }}
      />
      

      ) : field.type === 'date' ? (
        <input
          className="form-input"
          type="date"
          name={field.fields}
          value={value}
          onChange={handleChange}
          required
        />

      ) : (
        <input
          className="form-input"
          type="text"
          name={field.fields}
          value={value}
          onChange={handleChange}
          required
        />
      )}
    </div>
  );
};

export default FormFieldRenderer;
